module.exports = __webpack_public_path__ + "static/media/enabledNextIcon.875f8577.svg";